<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
:width="width" :height="height"><title>{{title}}</title><g
fill="#333333"><circle cx="13.116" cy="5.5" r="1"/><circle cx="16.366"
cy="5.5" r="1"/><circle cx="19.616" cy="5.5" r="1"/><path d="M18.5 0h-6a5.524
5.524 0 0 0-5.363 4.31 1 1 0 1 0 1.953.43A3.513 3.513 0 0 1 12.5 2h6a3.5 3.5 0
0 1 0 7h-1a1 1 0 0 0-.625.219l-.878.7A1 1 0 0 0 15 9h-1a1 1 0 0 0 0 2v1a1 1 0
0 0 1.625.781L17.85 11h.65a5.5 5.5 0 0 0 0-11z"/><path d="M11.5
17.329l-.63-.229a2.236 2.236 0 0 1-.08-1.608 5.621 5.621 0 0 0
1.466-4.315C12.256 8.756 10.677 7 8.5 7s-3.756 1.756-3.756 4.174A5.6 5.6 0 0 0
6.2 15.47a2.2 2.2 0 0 1-.067 1.63l-.632.233c-2.446.9-4.214 1.55-4.753
2.626A9.17 9.17 0 0 0 0 23.5a.5.5 0 0 0 .5.5h16a.5.5 0 0 0 .5-.5 9.17 9.17 0 0
0-.748-3.545c-.539-1.076-2.307-1.727-4.752-2.626z"/></g></svg></template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: '100%',
    },
    height: {
      type: [Number, String],
      default: '100%',
    },
    title: {
      type: String,
      default: 'person bubble',
    },
  },
};
</script>
